import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Mic, MicOff, Send, Bot, User, Volume2, VolumeX, X, Maximize2, Minimize2, Box, FileText } from "lucide-react";
import api from "../constant/api";
import { pdf } from "@react-pdf/renderer";
import InvoicePDF from "../pages/InvoicePDF";
import { Square, CheckSquare } from "lucide-react";

export default function AKAssistant() {
  const navigate = useNavigate();
  const location = useLocation();

  // States
  const [isOpen, setIsOpen] = useState(false);
  const [isMinimized, setIsMinimized] = useState(false);
  const [input, setInput] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [faqList, setFaqList] = useState([]); 
  const [selectedProducts, setSelectedProducts] = useState({});
  // const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(
  localStorage.getItem("selectedBranch") || "A K Ceramic World"
);
const [showSelectedDrawer, setShowSelectedDrawer] = useState(false);
const [billDate, setBillDate] = useState("");

   const [quotationId, setQuotationId] = useState(null);
    //  const [sessionActive, setSessionActive] = useState(false);
      // const [cart, setCart] = useState([]);

      useEffect(() => {
  const today = new Date().toISOString().split("T")[0];
  setBillDate(today);
}, []);

useEffect(() => {
  const savedId = localStorage.getItem("quotationId");
  if (savedId) {
    setQuotationId(savedId);
    // setSessionActive(true);
  }
}, []);
console.log("quotationId",quotationId)


  
  // வாய்ஸ் மற்றும் டைப்பிங் மொழி மாற்ற (Default: en-IN)
  const [activeLang, setActiveLang] = useState("en-IN");

  const [messages, setMessages] = useState([
    {
      sender: "ai",
      text: "வணக்கம்! நான் உங்கள் AK CRM உதவியாளர். நான் உங்களுக்கு எவ்வாறு உதவட்டும்? (English & தமிழ் commands supported)",
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    }
  ]);

  const toggleProductSelection = (item) => {
  setSelectedProducts((prev) => {
    const updated = { ...prev };
    if (updated[item.id]) delete updated[item.id];
    else updated[item.id] = item;
    return updated;
  });
};

const removeSelectedProduct = (id) => {
  setSelectedProducts((prev) => {
    const updated = { ...prev };
    delete updated[id];
    return updated;
  });
};

const clearSelectedProducts = () => {
  setSelectedProducts({});
};

const handleCreateQuotation = async () => {
  try {
    setIsLoading(true);

    const itemsArray = Object.values(selectedProducts);

    const quotationId = localStorage.getItem("quotationId");

    let res;

    if (quotationId) {
      // Existing quotation
      res = await api.post("/Ecom/AIUpdateQuotation", {
        quotation_id: quotationId,
        items: itemsArray,
      });
    } else {
      // New quotation
      res = await api.post("/Ecom/AicreateQuotation", {
        date: billDate,
        branch: selectedBranch,
        items: itemsArray,
      });

      localStorage.setItem("quotationId", res.data.quotation_id);
    }

    navigate("/Quotation");

    setSelectedProducts({});

    setIsOpen(false);
  } catch (error) {
    console.error(error);
    alert("Quotation Error");
  } finally {
    setIsLoading(false);
  }
};

  const messagesEndRef = useRef(null);
  const recognitionRef = useRef(null);

  // Auto-scroll to latest message
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // Initialize Speech Recognition
  useEffect(() => {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (SpeechRecognition) {
      const rec = new SpeechRecognition();
      rec.continuous = false;
      rec.interimResults = false;
      rec.lang = "en-IN";

      rec.onstart = () => setIsListening(true);
      rec.onend = () => setIsListening(false);
      
      rec.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setInput(transcript);
        handleSendMessage(transcript);
      };

      recognitionRef.current = rec;
    }
  }, []);

  const handleInvoicePrint = async (invoice_id) => {
    try {
      const res = await api.get(`/order/getInvoice/${invoice_id}`);
      const invoiceData = res.data.invoice;
      const invoiceNo = invoiceData?.invoice_no || invoice_id;

      const blob = await pdf(
        <InvoicePDF invoice={invoiceData} items={res.data.items} />
      ).toBlob();

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `Invoice_${invoiceNo}.pdf`; 
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

    } catch (err) {
      console.error("PDF Download Error:", err);
      alert("PDF டவுன்லோட் செய்வதில் சிக்கல் உள்ளது!");
    }
  };

  useEffect(() => {
    const loadFaqCommands = async () => {
      try {
        const res = await api.get("/ai/getFaqCommands");
        if (res.data && res.data.data) {
          setFaqList(res.data.data);
        }
      } catch (error) {
        console.error("Error loading FAQ commands in assistant:", error);
      }
    };
    loadFaqCommands();
  }, []);

  // Text-to-Speech
  const speakText = (text) => {
    if (isMuted || !window.speechSynthesis) return;
    
    const cleanText = text.replace(/[•\n]/g, " ").trim();
    const utterance = new SpeechSynthesisUtterance(cleanText);
    
    if (/[அ-ஹ]/.test(text) || text.includes("திறக்கிறேன்") || text.includes("வணக்கம்") || text.includes("விபரங்கள்") || text.includes("தொலைபேசி") || text.includes("மன்னிக்கவும்")) {
      utterance.lang = "ta-IN";
    } else {
      utterance.lang = "en-IN";
    }
    
    window.speechSynthesis.cancel();
    window.speechSynthesis.speak(utterance);
  };

  // --- 🌟 Advanced Dynamic Product Filter (Individual & Multi-filter Support) ---
 // --- 🌟 Highly Advanced Dynamic Product Filter Engine ---
const fetchProductsFromAPI = async (filters) => {
  try {
    const res = await api.get("/Product/getProduct");
    const allProducts = res.data?.data || res.data || [];
    console.log(allProducts[0]);
    const results = allProducts.filter((item) => {
      // 1. Brand Filter (Supports Exact and Sub-string matching)
      if (filters.brand) {
        const itemBrand = (item?.brand || "").toLowerCase().trim();
        if (!itemBrand.includes(filters.brand.toLowerCase().trim())) return false;
      }
      

      // 2. Size Filter (Normalizes spaces, 'x', and '*' characters)
      if (filters.size) {
        const itemSize = (item?.size || "").toLowerCase().replace(/[\s*x]/g, "");
        const targetSize = filters.size.toLowerCase().replace(/[\s*x]/g, "");
        if (!itemSize.includes(targetSize)) return false;
      }

      // 3. Price Filter (Supports Range, Less Than, Greater Than, and Equal To)
      if (filters.priceOpt) {
        const itemPrice = parseFloat(item?.price || 0);
        const { mode, value, min, max } = filters.priceOpt;

        if (!isNaN(itemPrice)) {
          if (mode === "below" && itemPrice > value) return false;
          if (mode === "above" && itemPrice < value) return false;
          if (mode === "equal" && itemPrice !== value) return false;
          if (mode === "range" && (itemPrice < min || itemPrice > max)) return false;
        }
      }

      // 4. Stock / Availability Logic Filter
      if (filters.stockOpt) {
        const itemQty = parseInt(item?.qty || 0, 10);
        if (filters.stockOpt === "available" && itemQty <= 0) return false;
        if (filters.stockOpt === "outofstock" && itemQty > 0) return false;
      }

      console.log("Search Query:", filters.query);
      // 5. General Search Query Fallback (Matches name or code)
    // 5. General Search Query Fallback (Matches name or code)
if (filters.query) {

  const normalize = (str) =>
    String(str)
      .toLowerCase()
      .replace(/[^a-z0-9 ]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const words = normalize(filters.query).split(" ");

  const productName = normalize(item?.product_name || "");
  const productCode = normalize(item?.product_code || "");

  const matched = words.every(
    (word) =>
      productName.includes(word) ||
      productCode.includes(word)
  );

  if (!matched) return false;
}

      return true;
    });

    return results.map((item) => {
      const rawPrice = item?.price || "0";
      const formattedPrice = typeof rawPrice === "number" || !String(rawPrice).includes("₹") ? `${rawPrice}` : rawPrice;
      return {
        id: item?.product_id || Math.random(),
        name: item?.product_name || "No Name",
        code: item?.product_code || "N/A",
        price: formattedPrice,
        stock: item?.qty !== undefined && item?.qty !== null ? `${item.qty}` : "0",
        image: item?.images || null,
        sqft:item.sqft_per_box || "0" 
      };
    });
  } catch (error) {
    console.error("Error inside Advanced AI Filter Engine:", error);
    return [];
  }
};

  // --- Real API Customer Fetch ---
  const fetchCustomersFromAPI = async (searchQuery) => {
    try {
      const res = await api.get("Product/getCustomers");
      const allCustomers = res.data?.data || res.data || [];
      const cleanQuery = searchQuery.toLowerCase().replace(/\s+/g, ""); 

      const results = allCustomers.filter((c) => {
        const custName = (c?.name || "").toLowerCase().replace(/\s+/g, "");
        const custPhone = (c?.phone || "").toString().toLowerCase().replace(/\s+/g, "");
        return custName.includes(cleanQuery) || custPhone.includes(cleanQuery);
      });

      return results.map((c) => ({
        id: c?.customer_id || Math.random(),
        name: c?.name || "No Name",
        phone: c?.phone || "N/A",
        status: c?.status || "Pending",
        isCustomer: true 
      }));
    } catch (error) {
      console.error("Error fetching customers inside AI Assistant:", error);
      return [];
    }
  };

  // --- Real API Invoice Fetch ---
  const fetchInvoicesByPhoneFromAPI = async (searchQuery) => {
    try {
      const res = await api.get("/order/getAllInvoices"); 
      const allInvoices = res.data?.data || res.data || [];
      const cleanQuery = searchQuery.toLowerCase().replace(/\s+/g, ""); 

      const results = allInvoices.filter((inv) => {
        const invPhone = (inv?.phone || inv?.customer_phone || "").toString().toLowerCase().replace(/\s+/g, "");
        const invCustName = (inv?.customer_name || inv?.name || "").toLowerCase().replace(/\s+/g, "");
        const invNo = (inv?.invoice_no || inv?.invoice_id || "").toString().toLowerCase().replace(/\s+/g, "");
        return invPhone.includes(cleanQuery) || invCustName.includes(cleanQuery) || invNo.includes(cleanQuery);
      });

      return results.map((inv) => ({
        id: inv?.invoice_id || inv?.id || Math.random(),
        invoiceNo: inv?.invoice_no || "N/A",
        customerName: inv?.customer_name || inv?.name || "Unknown Customer",
        phone: inv?.phone || inv?.customer_phone || "N/A",
        grandTotal: inv?.grand_total || inv?.total_amount || "0",
        date: inv?.date || inv?.created_at || "N/A",
        isInvoice: true 
      }));
    } catch (error) {
      console.error("Error fetching invoices inside AI Assistant:", error);
      return [];
    }
  };

  // Smart Front-end AI Engine
  const processAICommand = async (text) => {
    const cleanText = text.toLowerCase().trim();
    
    // FAQ சரிபார்த்தல்
    let matchedFaq = faqList.find((faq) => {
      const dbQuestion = (faq.question || "").toLowerCase().trim();
      return cleanText === dbQuestion || cleanText.includes(dbQuestion) || dbQuestion.includes(cleanText);
    });

    if (matchedFaq) {
      return { text: matchedFaq.answer }; 
    }

    // Navigation & Basic Commands
    if (cleanText === "dashboard" || cleanText === "home" || cleanText === "முகப்பு") {
      navigate("/");
      return { text: "Opening Dashboard... முகப்புப் பக்கம் திறக்கிறேன்." };
    }
    
    if (cleanText.includes("purchase") || cleanText.includes("கொள்முதல்") || cleanText === "po" || cleanText.includes("purchase order") || cleanText.includes("ஆர்டர்")) {
      navigate("/PurchaseOrder");
      return { text: "Opening Purchase Orders... கொள்முதல் பக்கத்தை திறக்கிறேன்." };
    }

    if (cleanText === "open product page" || cleanText === "product page" || cleanText === "product" || cleanText === "products" || cleanText === "பொருட்கள்") {
      navigate("/Products");
      return { text: "Opening Products Page... பொருட்கள் பக்கத்தை திறக்கிறேன்." };
    }

    if (cleanText === "create quotation" || cleanText.includes("add quotation") || cleanText.includes("கொட்டேஷன் உருவாக்கு") || cleanText === "quotation") {
      navigate("/Quotation");
      return { text: "Opening Create Quotation Page... கொட்டேஷன் உருவாக்கும் பக்கத்தை திறக்கிறேன்." };
    }
    
    if (cleanText.includes("quotation list") || cleanText.includes("all quotation") || cleanText.includes("கொட்டேஷன் பட்டியல்") || cleanText.includes("கொட்டேஷன் லிஸ்ட்")) {
      navigate("/QuotationList");
      return { text: "Opening Quotation List... கொட்டேஷன் பட்டியலைத் திறக்கிறேன்." };
    }

    if (cleanText.includes("inventory") || cleanText.includes("stock") || cleanText.includes("இருப்பு") || cleanText.includes("ஸ்டாக்") || cleanText.includes("சரக்கு")) {
      navigate("/Inventory");
      return { text: "Opening Inventory... ஸ்டாக் விபரப் பக்கத்தை திறக்கிறேன்." };
    }

    if (cleanText.includes("supplier") || cleanText.includes("suppliers") || cleanText.includes("vendor") || cleanText.includes("சப்ளையர்") || cleanText.includes("விற்பனையாளர்")) {
      navigate("/Supplier");
      return { text: "Opening Suppliers Page... சப்ளையர் பக்கத்தை திறக்கிறேன்." };
    }

    if (cleanText.includes("return") || cleanText.includes("product return") || cleanText.includes("sales return") || cleanText.includes("திருப்புதல்") || cleanText.includes("ரிட்டர்ன்")) {
      navigate("/ProductReturn");
      return { text: "Opening Product Returns... ரிட்டர்ன் பக்கத்தை திறக்கிறேன்." };
    }
    
    if (cleanText.includes("offer") || cleanText.includes("offers") || cleanText.includes("discount") || cleanText.includes("சலுகை") || cleanText.includes("தள்ளுபடி")) {
      navigate("/Offer");
      return { text: "Opening Offers Page... சலுகைகள் பக்கத்தை திறக்கிறேன்." };
    }
    
    if (cleanText.includes("contact") || cleanText.includes("contacts") || cleanText.includes("தொடர்பு") || cleanText.includes("முகவரி")) {
      navigate("/Contact");
      return { text: "Opening Contacts Page... தொடர்புகள் பக்கத்தை திறக்கிறேன்." };
    }

    if (cleanText.includes("add product") || cleanText.includes("new product") || cleanText.includes("பொருள் சேர்") || cleanText.includes("புதிய பொருள்")) {
      navigate("/add-product");
      return { text: "Opening Add Product Page... புதிய பொருள் சேர்க்கும் பக்கத்தை திறக்கிறேன்." };
    }

    // Customer / Invoice Keywords
    const isCustomerKeywordPresent = cleanText.includes("customer") || cleanText.includes("வாடிக்கையாளர்") || cleanText.includes("client");
    const isInvoiceKeywordPresent = cleanText.includes("invoice") || cleanText.includes("இன்வாய்ஸ்") || cleanText.includes("பில்");

    const finalQuery = cleanText
      .replace(/search|customer|customers|client|find|product|products|tile|tiles|invoice|invoices|தேடு|வாடிக்கையாளர்|கடுத்துபிடி|பொருட்கள்|இன்வாய்ஸ்|பில்/g, "")
      .trim() || cleanText;

    setIsLoading(true);

    // 1. Customer பில்டரிங்
    if (isCustomerKeywordPresent && !isInvoiceKeywordPresent) {
      const custResults = await fetchCustomersFromAPI(finalQuery);
      setIsLoading(false);
      if (custResults && custResults.length > 0) {
        navigate(`/Customers?search=${encodeURIComponent(finalQuery)}`);
        return { text: `Found ${custResults.length} customer(s). வாடிக்கையாளர் விபரங்கள் கீழே உள்ளன:`, items: custResults };
      }
      navigate("/Customers");
      return { text: `மன்னிக்கவும், "${finalQuery}" என்ற பெயரில் வாடிக்கையாளர் இல்லை.` };
    }

    // 2. Invoice பில்டரிங்
    if (isInvoiceKeywordPresent) {
      const custResults = await fetchCustomersFromAPI(finalQuery);
      const invResults = await fetchInvoicesByPhoneFromAPI(finalQuery);
      setIsLoading(false);
      if (custResults.length > 0 || invResults.length > 0) {
        navigate(`/Invoice?search=${encodeURIComponent(finalQuery)}`);
        return { text: `Results for "${finalQuery}": விபரங்கள் கீழே கார்டுகளாக கொடுக்கப்பட்டுள்ளன.`, items: [...custResults, ...invResults] };
      }
      navigate("/Invoice");
      return { text: `மன்னிக்கவும், இன்வாய்ஸ் விபரங்கள் எதுவும் இல்லை.` };
    }

    // =========================================================================
    // 🚀 ADVANCED NLP PARSING LOGIC FOR PRODUCTS (Multi-language Support)
    // =========================================================================
    let productFilters = { 
      brand: null, 
      size: null, 
      priceOpt: null, 
      stockOpt: null, 
      query: null 
    };

    // A. Detect Stock Conditions
    if (cleanText.includes("out of stock") || cleanText.includes("ஸ்டாக் இல்லை") || cleanText.includes("காலி")) {
      productFilters.stockOpt = "outofstock";
    } else if (cleanText.includes("available") || cleanText.includes("stock") || cleanText.includes("இருப்பு") || cleanText.includes("ஸ்டாக்")) {
      productFilters.stockOpt = "available";
    }

    // B. Advanced Price Operator Parser (Below, Above, Between Ranges)
    const rangeRegex = /(?:between|இருந்து|வரை)\s*(\d+)\s*(?:and|to|முதல்|-)\s*(\d+)/i;
    const belowRegex = /(?:below|less than|under|குறைவாக|குள்ள|கீழே)\s*(\d+)/i;
    const aboveRegex = /(?:above|greater than|more than|அதிகமாக|மேலே)\s*(\d+)/i;
    const exactPriceRegex = /(?:price|rate|மதிப்பு|விலை)\s*(\d+)/i;

    const rangeMatch = cleanText.match(rangeRegex);
    const belowMatch = cleanText.match(belowRegex);
    const aboveMatch = cleanText.match(aboveRegex);
    const exactMatch = cleanText.match(exactPriceRegex);

    if (rangeMatch) {
      productFilters.priceOpt = { mode: "range", min: parseFloat(rangeMatch[1]), max: parseFloat(rangeMatch[2]) };
    } else if (belowMatch) {
      productFilters.priceOpt = { mode: "below", value: parseFloat(belowMatch[1]) };
    } else if (aboveMatch) {
      productFilters.priceOpt = { mode: "above", value: parseFloat(aboveMatch[1]) };
    } else if (exactMatch) {
      productFilters.priceOpt = { mode: "equal", value: parseFloat(exactMatch[1]) };
    } else {
  // Price keyword இருந்தால் மட்டும் number-ஐ Price ஆக எடுத்துக்கொள்ளவும்
  const hasPriceKeyword =
    cleanText.includes("price") ||
    cleanText.includes("rate") ||
    cleanText.includes("விலை") ||
    cleanText.includes("மதிப்பு") ||
    cleanText.includes("₹");

  if (hasPriceKeyword) {
    const genericNumbers = cleanText.match(/\b\d+(\.\d+)?\b/g);

    if (genericNumbers) {
      if (genericNumbers.length === 2) {
        productFilters.priceOpt = {
          mode: "range",
          min: parseFloat(genericNumbers[0]),
          max: parseFloat(genericNumbers[1]),
        };
      } else if (genericNumbers.length === 1) {
        productFilters.priceOpt = {
          mode: "equal",
          value: parseFloat(genericNumbers[0]),
        };
      }
    }
  }
}

    // C. Size Formatter Regex (Extracts dimensions like 2x2, 600 * 600, 300x450)
    const sizeRegex = /(\d+\s*[x*]\s*\d+)/i;
    const sizeMatch = cleanText.match(sizeRegex);
    if (sizeMatch) {
      productFilters.size = sizeMatch[1];
    }

    // D. Brand Dictionary Match Loop
    const knownBrands = ["somany", "kajaria", "johnson", "varmora", "nitco", "orient", "rak", "simpolo", "hindware", "cera"];
    knownBrands.forEach(b => {
      if (cleanText.includes(b)) productFilters.brand = b;
    });

    // Fallback descriptor context: explicit word declaration (e.g., "Anuj brand")
    const explicitBrandMatch = cleanText.match(/brand\s+([a-z0-9]+)/i) || cleanText.match(/([a-z0-9]+)\s+brand/i);
    if (explicitBrandMatch && !productFilters.brand) {
      productFilters.brand = explicitBrandMatch[1];
    }

    // E. Extract Leftover text into general description queries
    let cleanQueryText = finalQuery
      .replace(rangeRegex, "")
      .replace(belowRegex, "")
      .replace(aboveRegex, "")
      .replace(exactPriceRegex, "")
      .replace(sizeRegex, "")
      .replace(/brand|size|price|rate|stock|available|விலை|அளவு|பிராண்ட்|இருப்பு|ஸ்டாக்/gi, "")
      .trim();

    if (productFilters.brand) {
      cleanQueryText = cleanQueryText.replace(productFilters.brand, "");
    }
    
    cleanQueryText = cleanQueryText.replace(/\s+/g, " ").trim();
    if (cleanQueryText.length > 1) {
      productFilters.query = cleanQueryText;
    }

    // Process structured array results from API
    const apiResults = await fetchProductsFromAPI(productFilters);
    setIsLoading(false);

    console.log("Final Query:", productFilters.query);
console.log("Filters:", productFilters);

    if (apiResults && apiResults.length > 0) {
      // Build dynamic routing queries for sync to the main Products URL page 
      let searchParams = [];
      if (productFilters.brand) searchParams.push(`brand=${productFilters.brand}`);
      if (productFilters.size) searchParams.push(`size=${productFilters.size}`);
      if (productFilters.priceOpt) {
        if (productFilters.priceOpt.mode === "range") searchParams.push(`minPrice=${productFilters.priceOpt.min}&maxPrice=${productFilters.priceOpt.max}`);
        else searchParams.push(`price=${productFilters.priceOpt.value}&mode=${productFilters.priceOpt.mode}`);
      }
      if (productFilters.stockOpt) searchParams.push(`stock=${productFilters.stockOpt}`);
      if (productFilters.query) searchParams.push(`search=${productFilters.query}`);
      
      navigate(`/Products?${searchParams.join("&")}`);

      // Generate conversational contextual breakdown feedback message
      let filterMsg = "உங்களது தேடல் விபரங்கள் அடிப்படையில் கண்டறியப்பட்ட பொருட்கள் இதோ:\n";
      if (productFilters.brand) filterMsg += `• பிராண்ட்: ${productFilters.brand.toUpperCase()}\n`;
      if (productFilters.size) filterMsg += `• அளவு (Size): ${productFilters.size}\n`;
      if (productFilters.priceOpt) {
        if (productFilters.priceOpt.mode === "range") filterMsg += `• விலை வரம்பு: ₹${productFilters.priceOpt.min} - ₹${productFilters.priceOpt.max}\n`;
        if (productFilters.priceOpt.mode === "below") filterMsg += `• விலை: ₹${productFilters.priceOpt.value} க்குக் குறைவாக\n`;
        if (productFilters.priceOpt.mode === "above") filterMsg += `• விலை: ₹${productFilters.priceOpt.value} க்கும் அதிகமாக\n`;
        if (productFilters.priceOpt.mode === "equal") filterMsg += `• விலை: ₹${productFilters.priceOpt.value}\n`;
      }
      if (productFilters.stockOpt) filterMsg += `• இருப்பு நிலை: ${productFilters.stockOpt === "available" ? "ஸ்டாக் உள்ளது" : "ஸ்டாக் இல்லை"}\n`;

      return {
        text: `Found ${apiResults.length} product(s).\n\n${filterMsg}`,
        items: apiResults
      };
    }
    
    // கஸ்டமர் / இன்வாய்ஸ் பொது தேடல் Fallback
    const fallbackCust = await fetchCustomersFromAPI(finalQuery);
    const fallbackInv = await fetchInvoicesByPhoneFromAPI(finalQuery);
    if (fallbackCust.length > 0 || fallbackInv.length > 0) {
      return { text: `பொருட்கள் எதுவும் கிடைக்கவில்லை, ஆனால் உங்களது தேடலுக்குப் பொருத்தமான வாடிக்கையாளர்/இன்வாய்ஸ் விபரங்கள் இதோ:`, items: [...fallbackCust, ...fallbackInv] };
    }

    return { text: `மன்னிக்கவும், நீங்கள் கேட்ட பில்டர் விபரங்களில் எந்தவொரு பொருளும் கண்டறியப்படவில்லை.` };
  };

  // Handle Send Actions
  const handleSendMessage = async (textToSend) => {
    const messageText = textToSend || input;
    if (!messageText.trim()) return;

    const userMsg = {
      sender: "user",
      text: messageText,
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };

    setMessages((prev) => [...prev, userMsg]);
    setInput("");

    const responseObj = await processAICommand(messageText);
    
    const aiMsg = {
      sender: "ai",
      text: responseObj.text,
      items: responseObj.items || null, 
      time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
    };
    
    setMessages((prev) => [...prev, aiMsg]);
    speakText(responseObj.text);
  };

  const toggleListening = () => {
    if (!recognitionRef.current) {
      alert("Speech recognition is not supported in this browser. Try Chrome.");
      return;
    }
    if (isListening) {
      recognitionRef.current.stop();
    } else {
      recognitionRef.current.lang = activeLang; 
      recognitionRef.current.start();
    }
  };

  if (!isOpen) {
    return (
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-24 right-5 sm:bottom-6 sm:right-6 w-14 h-14 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-105 transition-all z-50 animate-bounce"
      >
        <Bot size={28} />
      </button>
    );
  }

  return (
    <div
      className={`fixed left-0 right-0 bottom-0 sm:left-auto sm:right-6 sm:bottom-6 w-full sm:w-96 bg-slate-900 border border-slate-800 sm:rounded-2xl shadow-2xl flex flex-col overflow-hidden z-50 transition-all duration-300 ${
        isMinimized ? "h-16" : "h-[75vh] sm:h-[545px]"
      }`}
    >
      {/* Header */}
      <div className="p-4 bg-slate-950 border-b border-slate-800 flex items-center justify-between text-white select-none">
        <div className="flex items-center gap-2">
          <div className={`w-3 h-3 rounded-full ${isLoading ? "bg-amber-500 animate-spin border-t-transparent" : "bg-green-500 animate-pulse"}`} />
          <span className="font-bold tracking-wide text-xs sm:text-sm flex items-center gap-1.5">
            <Bot size={18} className="text-blue-400" /> AK AI ASSISTANT
          </span>
        {Object.keys(selectedProducts).length > 0 && (
  <button
    onClick={() => setShowSelectedDrawer(true)}
    className="fixed bottom-24 right-5 z-[9999] bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-5 py-3 rounded-full shadow-2xl hover:scale-105 transition-all duration-300"
  >
    📦({Object.keys(selectedProducts).length})
  </button>
)}
        </div>
        <div className="flex items-center gap-2.5 text-slate-400">
          <button onClick={() => setIsMuted(!isMuted)} className="hover:text-white p-1">
            {isMuted ? <VolumeX size={16} /> : <Volume2 size={16} />}
          </button>
          <button onClick={() => setIsMinimized(!isMinimized)} className="hover:text-white p-1 hidden sm:block">
            {isMinimized ? <Maximize2 size={16} /> : <Minimize2 size={16} />}
          </button>
          <button onClick={() => setIsOpen(false)} className="hover:text-rose-400 p-1">
            <X size={16} />
          </button>
        </div>
      </div>

      {/* Main Body */}
      {!isMinimized && (
        <>
          {/* Chat Messages */}
          <div className="flex-1 p-4 overflow-y-auto space-y-4 bg-slate-900/50 custom-scrollbar">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`flex flex-col gap-1 max-w-[88%] sm:max-w-[85%] ${
                  msg.sender === "user" ? "ml-auto items-end" : "mr-auto items-start"
                }`}
              >
                <div className={`flex gap-2.5 ${msg.sender === "user" ? "flex-row-reverse" : ""}`}>
                  <div
                    className={`w-7 h-7 rounded-full flex items-center justify-center text-xs flex-shrink-0 ${
                      msg.sender === "user" ? "bg-blue-600 text-white" : "bg-slate-800 text-blue-400"
                    }`}
                  >
                    {msg.sender === "user" ? <User size={14} /> : <Bot size={14} />}
                  </div>
                  <div className="w-full">
                    <div
                      className={`p-3 rounded-2xl text-xs sm:text-sm whitespace-pre-line leading-relaxed ${
                        msg.sender === "user"
                          ? "bg-blue-600 text-white rounded-tr-none"
                          : "bg-slate-800 text-slate-100 rounded-tl-none border border-slate-700/50"
                      }`}
                    >
                      {msg.text}
                    </div>

                    {/* Dynamic API Cards UI Rendering */}
                    {msg.items && msg.items.length > 0 && (
                      <div className="mt-4 space-y-3 w-full min-w-[240px] sm:min-w-[300px]">
                        {msg.items.map((item) => {
                          // 1. CUSTOMER CARD
                          if (item.isCustomer) {
                            return (
                              <div 
                                key={`cust-${item.id}`} 
                                onClick={() => {
                                  if (item.phone && item.phone !== "N/A") {
                                    window.location.href = `tel:${item.phone}`;
                                  } else {
                                    alert("இந்த வாடிக்கையாளருக்கு மொபைல் எண் இல்லை!");
                                  }
                                }} 
                                className="relative overflow-hidden bg-slate-900/40 backdrop-blur-xl border border-white/5 rounded-2xl p-3.5 sm:p-4 hover:border-emerald-500/40 hover:bg-slate-800/60 transition-all duration-300 shadow-lg cursor-pointer group hover:-translate-y-0.5"
                              >
                                <div className="absolute -right-6 -top-6 w-24 h-24 bg-emerald-500/10 rounded-full blur-2xl pointer-events-none"></div>
                                <div className="relative z-10 flex items-center justify-between gap-3">
                                  <div className="flex items-center gap-2.5 min-w-0">
                                    <div className="w-9 h-9 rounded-full bg-gradient-to-br from-emerald-500/20 to-teal-500/10 border border-emerald-500/30 flex items-center justify-center flex-shrink-0 group-hover:scale-110 group-hover:bg-emerald-500 group-hover:text-white transition-all duration-300">
                                      <span className="text-sm font-bold text-emerald-400 group-hover:text-white transition-colors">📞</span>
                                    </div>
                                    <div className="min-w-0">
                                      <h4 className="text-xs sm:text-sm font-bold text-slate-100 truncate group-hover:text-emerald-400 transition-colors">
                                        {item.name}
                                      </h4>
                                      <div className="mt-0.5 flex items-center gap-1.5 text-[11px] text-slate-400">
                                        <span>எண்:</span>
                                        <span className="text-white font-medium group-hover:underline">{item.phone}</span>
                                      </div>
                                    </div>
                                  </div>
                                  <span className="text-[9px] px-2 py-1 rounded-md font-bold uppercase tracking-wider bg-emerald-500/10 text-emerald-400 border border-emerald-500/20 flex-shrink-0 group-hover:bg-emerald-500/20 group-hover:border-emerald-500/40 transition-all">
                                    Call
                                  </span>
                                </div>
                              </div>
                            );
                          }  
                          // 2. INVOICE CARD
                          else if (item.isInvoice) {
                            return (
                              <div 
                                key={`inv-${item.id}`} 
                                onClick={() => handleInvoicePrint(item.id)} 
                                className="relative overflow-hidden bg-slate-900/40 backdrop-blur-xl border border-white/5 rounded-2xl p-3.5 sm:p-4 hover:border-blue-500/40 hover:bg-slate-800/60 transition-all duration-300 shadow-lg cursor-pointer group hover:-translate-y-0.5"
                              >
                                <div className="absolute -left-6 -bottom-6 w-24 h-24 bg-blue-500/10 rounded-full blur-2xl pointer-events-none"></div>
                                <div className="relative z-10">
                                  <div className="flex justify-between items-center mb-2.5 pb-2.5 border-b border-white/5 border-dashed">
                                    <div className="flex items-center gap-2 min-w-0">
                                      <div className="p-1.5 rounded-lg bg-blue-500/10 border border-blue-500/20 text-blue-400 flex-shrink-0 group-hover:bg-blue-600 group-hover:text-white transition-colors duration-300">
                                        <FileText size={14} />
                                      </div>
                                      <h4 className="text-xs sm:text-sm font-bold text-slate-200 tracking-wide truncate">
                                        INV-<span className="text-blue-400 group-hover:text-blue-300 transition-colors">{item.invoiceNo}</span>
                                      </h4>
                                    </div>
                                    <span className="text-sm sm:text-lg font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400">
                                      ₹{item.grandTotal}
                                    </span>
                                  </div>
                                  <div className="flex justify-between items-center text-[11px]">
                                    <div className="flex flex-col min-w-0 pr-2">
                                      <span className="text-slate-500 uppercase text-[8px] font-bold tracking-wider mb-0.5">Billed To</span>
                                      <span className="text-slate-200 font-medium truncate">{item.customerName}</span>
                                    </div>
                                    <div className="flex flex-col items-end flex-shrink-0">
                                      <span className="text-slate-500 uppercase text-[8px] font-bold tracking-wider mb-0.5">Date</span>
                                      <span className="text-slate-300 font-mono bg-slate-950/50 px-1.5 py-0.5 rounded border border-white/5">{item.date}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                          // 3. PRODUCT CARD (With Brand/Size Highlight)
                          else {
                            const isSelected = !!selectedProducts[item.id];
                            return (
                              <div 
                                key={`prod-${item.id}`} 
                                onClick={() => navigate(`/edit-product/${item.id}`)} 
                                className="relative overflow-hidden bg-slate-900/50 backdrop-blur-xl border border-white/5 rounded-2xl p-3 hover:border-purple-500/50 hover:bg-slate-800/80 transition-all duration-300 shadow-xl cursor-pointer flex gap-3 items-center group hover:-translate-y-0.5"
                              >
                                <div className="absolute right-0 top-0 w-24 h-24 bg-gradient-to-bl from-purple-500/5 to-transparent rounded-full blur-xl pointer-events-none"></div>
         <button
  onClick={(e) => {
    e.stopPropagation(); // Parent click-ஐ நிறுத்தும்
    toggleProductSelection(item);
  }}
  className="p-2 rounded-lg hover:bg-slate-700 transition"
>
  {isSelected ? (
    <CheckSquare
      size={22}
      className="text-emerald-500"
      strokeWidth={2.5}
    />
  ) : (
    <Square
      size={22}
      className="text-slate-400"
      strokeWidth={2}
    />
  )}
</button>
                                <div className="relative w-16 h-16 sm:w-24 sm:h-24 flex-shrink-0">
                                  {item.image ? (
                                    <img
                                      src={`https://akceramicworldadmin.unitdtechnologies.com/uploads/${item.image}`}
                                      alt={item.name}
                                      className="w-full h-full object-cover rounded-xl border border-white/10 shadow-md group-hover:scale-105 transition-transform duration-300 z-10 relative"
                                    />
                                  ) : (
                                    <div className="w-full h-full rounded-xl bg-gradient-to-br from-slate-800 to-slate-900 border border-white/5 flex flex-col items-center justify-center shadow-inner z-10 relative">
                                      <Box size={20} className="text-slate-600 mb-0.5" />
                                      <span className="text-[8px] text-slate-500 uppercase">No Image</span>
                                    </div>
                                  )}
                                  <div className={`absolute -bottom-1.5 -right-1.5 px-1.5 py-0.5 rounded-md text-[8px] font-bold tracking-wide z-20 shadow-md border backdrop-blur-md flex items-center gap-0.5 ${
                                    Number(item.stock) > 0 
                                      ? 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30' 
                                      : 'bg-rose-500/20 text-rose-400 border-rose-500/30'
                                  }`}>
                                    {Number(item.stock) > 0 ? 'IN' : 'OUT'}
                                  </div>
                                </div>
                                <div className="flex-1 min-w-0 flex flex-col h-full justify-between">
                                  <div>
                                    <div className="flex items-center gap-1.5 mb-1">
                                      <span className="text-[8px] font-mono bg-slate-950/60 text-slate-400 px-1.5 py-0.5 rounded border border-white/5 uppercase tracking-wider truncate max-w-[100px]">
                                        {item.code}
                                      </span>
                                    </div>
                                    <h4 className="text-xs sm:text-sm font-bold text-slate-100 group-hover:text-purple-400 break-words line-clamp-2 transition-colors leading-tight">
                                      {item.name}
                                    </h4>
                                  </div>
                                  <div className="mt-2 flex items-center justify-between bg-slate-950/40 rounded-xl px-2.5 py-1.5 border border-white/5 shadow-inner text-[11px]">
                                    <div className="flex flex-col">
                                      <span className="text-[8px] text-slate-500 uppercase font-medium">Price</span>
                                      <b className="text-xs text-white font-bold">{item.price}</b>
                                    </div>
                                    <div className="w-[1px] h-4 bg-white/10 rounded-full"></div>
                                    <div className="flex flex-col items-end">
                                      <span className="text-[8px] text-slate-500 uppercase font-medium">Qty</span>
                                      <b className="text-xs font-bold text-emerald-400">{item.stock}</b>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }
                        })}
                      </div>
                    )}
                  </div>
                </div>
                <span className="text-[10px] text-slate-500 block px-1 mt-0.5">
                  {msg.time}
                </span>
              </div>
            ))}
            
            {isLoading && (
              <div className="flex gap-2.5 max-w-[85%] mr-auto items-center text-slate-400 text-xs">
                <div className="w-7 h-7 rounded-full bg-slate-800 flex items-center justify-center text-blue-400">
                  <Bot size={14} />
                </div>
                <div className="bg-slate-800 p-3 rounded-2xl rounded-tl-none flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
                  <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
                  <span className="w-1.5 h-1.5 bg-blue-500 rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Language Switcher */}
          <div className="flex bg-slate-950 border-t border-slate-800 select-none">
            <button
              onClick={() => setActiveLang("en-IN")}
              className={`flex-1 py-2 text-xs font-bold transition-all duration-300 ${
                activeLang === "en-IN"
                  ? "bg-blue-600/10 text-blue-400 border-b-2 border-blue-500 font-extrabold"
                  : "text-slate-500 hover:bg-slate-900 hover:text-slate-400"
              }`}
            >
              English
            </button>
            <button
              onClick={() => setActiveLang("ta-IN")}
              className={`flex-1 py-2 text-xs font-bold transition-all duration-300 ${
                activeLang === "ta-IN"
                  ? "bg-blue-600/10 text-blue-400 border-b-2 border-blue-500 font-extrabold"
                  : "text-slate-500 hover:bg-slate-900 hover:text-slate-400"
              }`}
            >
              தமிழ்
            </button>
          </div>

          {/* Input Panel */}
          <div className="p-3 bg-slate-950 border-t border-slate-800 flex items-center gap-2 pb-4 sm:pb-3">
            <button
              onClick={toggleListening}
              className={`p-3 rounded-xl flex items-center justify-center transition-all flex-shrink-0 ${
                isListening
                  ? "bg-rose-600 text-white animate-pulse"
                  : "bg-slate-800 text-slate-300 hover:bg-slate-700"
              }`}
            >
              {isListening ? <MicOff size={18} /> : <Mic size={18} />}
            </button>
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
              placeholder={activeLang === "ta-IN" ? "எ.கா: somany brand 2x2 விலை 500" : "Eg: Kajaria brand 600x600 price below 400..."}
              className="flex-1 bg-slate-950 border border-slate-800 rounded-xl px-3 py-2 text-xs sm:text-sm focus:outline-none focus:border-blue-500 text-slate-100 placeholder-slate-500"
            />
            <button onClick={() => handleSendMessage()} className="p-3 bg-blue-600 hover:bg-blue-500 text-white rounded-xl flex items-center justify-center flex-shrink-0">
              <Send size={16} />
            </button>
          </div>
        </>
      )}
      {showSelectedDrawer && (
  <div className="fixed inset-0 bg-black/60 z-[9999] flex justify-end">
    <div className="w-full sm:w-[420px] h-full bg-slate-900 shadow-2xl flex flex-col">

      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-slate-700">
        <h2 className="text-xl font-bold text-white">
          📦 Selected Products
        </h2>

        <button
          onClick={() => setShowSelectedDrawer(false)}
          className="text-white text-2xl"
        >
          ✕
        </button>
      </div>

      {/* Products */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">

        {Object.values(selectedProducts).map((item) => (

          <div
            key={item.id}
            className="bg-slate-800 rounded-xl p-3 flex gap-3 items-center"
          >

            <img
              src={`https://akceramicworldadmin.unitdtechnologies.com/uploads/${item.image}`}
              className="w-16 h-16 rounded-lg object-cover"
              alt=""
            />

            <div className="flex-1">

              <h3 className="text-white font-semibold">
                {item.name}
              </h3>

              <p className="text-slate-400 text-sm">
                {item.code}
              </p>

              <p className="text-green-400 font-bold">
                {item.price}
              </p>

            </div>

            <button
              onClick={() => removeSelectedProduct(item.id)}
              className="bg-red-600 hover:bg-red-500 text-white px-3 py-2 rounded-lg"
            >
              Remove
            </button>

          </div>

        ))}

      </div>

      {/* Footer */}

      <div className="border-t border-slate-700 p-4">

        <div className="flex justify-between text-white mb-4">
          <span>
            Total Selected
          </span>

          <span>
            {Object.keys(selectedProducts).length}
          </span>
        </div>

        <button
          onClick={clearSelectedProducts}
          className="w-full bg-red-600 hover:bg-red-500 text-white py-3 rounded-xl mb-3"
        >
          🗑 Clear All
        </button>

        <button
          onClick={handleCreateQuotation}
          className="w-full bg-green-600 hover:bg-green-500 text-white py-3 rounded-xl font-bold text-lg"
        >
          ✅ Create Quotation
        </button>

      </div>

    </div>
  </div>
)}
    </div>
    
  );
  
}